import { Operations } from "../../operations/operations.entity";
import { QaQcOperations } from "../qa-qc-operations.entity";
import { QaQcData } from "./qa-qc-data.dto";

export class QaQcDataAdapter{
    public convertDtoToEntity(testDto: QaQcData):QaQcOperations{
        const qaQcOp = new QaQcOperations;
        qaQcOp.testCode = testDto.testCode
        qaQcOp.testName = testDto.testName
        qaQcOp.operationInfo = new Operations
        qaQcOp.operationInfo.operationId = testDto.operationInfo
        qaQcOp.isActive = testDto.isActive
            if(testDto.qaQcTestId){
                qaQcOp.updatedUser = testDto.updatedUser
                qaQcOp.qaQcTestId = testDto.qaQcTestId
            }else{
                qaQcOp.createdUser = testDto.createdUser
            }
        return qaQcOp;
    }
}